import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage4(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(refs.texts.prayerPre.current, { alpha: 1, duration: 2 }, 'stage4');

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage4',
    animations: [
      { x: vw(0.288), y: vh(-0.61), duration: 3 },
      { x: vw(-0.275), y: vh(-0.586), duration: 3 },
      { x: vw(0.465), y: vh(-0.374), duration: 3 },
      { x: vw(-0.387), y: vh(-0.297), duration: 3 },
      { x: vw(-0.105), y: vh(-0.199), duration: 3 },
      { x: vw(0.284), y: vh(-0.212), duration: 3 },
    ],
  });
}
